const API_URL_BY_ENV = {
    local: process.env.REACT_APP_API_URL_LOCAL,
    dev: process.env.REACT_APP_API_URL_DEV,
    prod: process.env.REACT_APP_API_URL_PROD,
};

const resolveApiUrl = (envStr) => {
    if (process.env.REACT_APP_API_URL) {
        return process.env.REACT_APP_API_URL;
    }
    return API_URL_BY_ENV[envStr] || API_URL_BY_ENV.dev || "";
};

const envStr = process.env.REACT_APP_ENV || "dev";

export const ENV = {
    apiUrl: resolveApiUrl(envStr),
    isProduction: envStr === "prod",
    jitsiDomain: process.env.REACT_APP_JITSI_DOMAIN || "meet.zenambilisim.com.tr",
};

export const environment = ENV;
